export default __webpack_public_path__ + "static/media/mw4.a10e5108.webp";